import { matchRoutes, type RouteObject } from 'react-router-dom'

/**
 * The route table is deliberately pure. `App` owns the legacy-compatible
 * history bridge for this migration slice, while React Router owns the URL
 * grammar and parameter extraction so route identity cannot drift between the
 * shell, deep links, and tests.
 */
export const routeTable: RouteObject[] = [
  { id: 'landing', path: '/' },
  { id: 'login', path: '/login' },
  { id: 'privacy', path: '/app/legal/privacy' },
  { id: 'terms', path: '/app/legal/terms' },
  { id: 'overview', path: '/app' },
  { id: 'overview', path: '/app/' },
  { id: 'rent', path: '/app/rent' },
  { id: 'rent-hosts', path: '/app/rent/hosts' },
  { id: 'rental-path', path: '/app/rent/path' },
  { id: 'configure', path: '/app/rent/configure' },
  { id: 'review', path: '/app/rent/review' },
  { id: 'direct-rental', path: '/app/rent/direct' },
  { id: 'offers', path: '/app/rent/offers/:dseq' },
  { id: 'instances', path: '/app/instances' },
  { id: 'instance', path: '/app/instances/:dseq' },
  { id: 'billing', path: '/app/billing' },
  { id: 'docs', path: '/app/docs' },
  { id: 'guide', path: '/app/docs/:slug' },
  { id: 'settings', path: '/app/settings' },
  { id: 'sdl', path: '/app/advanced/sdl' },
  { id: 'activity', path: '/app/advanced/activity' },
  { id: 'ops-overview', path: '/app/ops' },
  { id: 'ops-hosts', path: '/app/ops/hosts/:id?' },
  { id: 'ops-workloads', path: '/app/ops/workloads' },
  { id: 'ops-failover', path: '/app/ops/failover' },
  { id: 'ops-diagnostics', path: '/app/ops/diagnostics' },
  { id: 'ops-logs', path: '/app/ops/logs' },
  { id: 'ops-admin', path: '/app/ops/admin' },
  { id: 'ops-versions', path: '/app/ops/versions' },
]

export interface AppRouteMatch {
  id: string
  params: Record<string, string | undefined>
}

export function matchAppRoute(pathname: string): AppRouteMatch | null {
  const match = matchRoutes(routeTable, { pathname })?.at(-1)
  if (!match || typeof match.route.id !== 'string') return null
  return { id: match.route.id, params: match.params }
}
